<template>
  <form class="collectReviewForm" @submit="onSubmitInformation" @reset="onReset" v-if="!showMobile">
    <div class="row">
      <div id="kontaktGroup" class="clearfix mb2 col-6">
        <p class="h5 darkblue gibson line-height-1 mb1">
          Kontaktperson
        </p>
        <b-form-input id="contactPerson" type="text" v-model="items.Kontaktperson" required placeholder="" class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
      </div>
      <div class="clearfix mb2 col-6">
        <p class="h5 darkblue gibson line-height-1 mb1">
          Firmanavn
        </p>
        <b-form-input id="companyName" type="text" v-model="items.Firma" required placeholder="" class="muted-background p2 h5 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
      </div>
    </div>
    <div class="row">
      <div id="addressGroup" class="clearfix mb2 col-6">
        <p class="h5 darkblue gibson line-height-1 mb1">
          Adresse
        </p>
        <b-form-input id="address" type="text" v-model="items.Adresse" required placeholder="" class="muted-background p2 h5 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
      </div>
      <div id="postGroup" class="clearfix mb2 col-6">
        <p class="h5 darkblue gibson line-height-1 mb1">
          Postnr
        </p>
        <b-form-input id="Postnr" type="text" v-model="items.Postnr" required placeholder="" class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
      </div>
    </div>
    <div class="row">
      <div id="telGroup" class="clearfix mb2 col-6">
        <p class="h5 darkblue gibson line-height-1 mb1">
          Telefon
        </p>
        <b-form-input id="telephone" type="text" v-model="items.Telefon" required placeholder="" class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
      </div>
      <div id="mobilnummerGroup" class="clearfix mb2 col-6">
        <p class="h5 darkblue gibson line-height-1 mb1">
          Mobilnummer
        </p>
        <b-form-input id="mobilnummer" type="text" v-model="items.Mobil" required placeholder="" class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
      </div>
    </div>
    <div class="row">
      <div id="emailGroup" class="clearfix mb2 col-6">
        <p class="h5 darkblue gibson line-height-1 mb1">
          Email
        </p>
        <b-form-input id="email" type="text" v-model="items.Email" required placeholder="" disabled class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
      </div>
      <div id="cvrGroup" class="clearfix mb2 col-6">
        <p class="h5 darkblue gibson line-height-1 mb1">
          CVR
        </p>
        <b-form-input id="cvr" type="text" v-model="items.Cvrnr" required placeholder="" disabled class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
      </div>
    </div>
    <div class="row">
      <div id="antalGroup" class="clearfix mb2 col-6">
        <p class="h5 darkblue gibson line-height-1 mb1">
          Antal medarbejdere
        </p>
        <b-form-input id="antal" type="text" v-model="items.AntalAnsatte" placeholder="" class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
      </div>
      <div id="yearGroup" class="clearfix mb2 col-6">
        <p class="h5 darkblue gibson line-height-1 mb1">
          Etableringsår
        </p>
        <b-form-input id="year" type="text" v-model="items.Etableringsaar" placeholder="" class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
      </div>
    </div>
    <div class="row">
      <div id="hjemmesideGroup" class="clearfix mb2 col-6">
        <p class="h5 darkblue gibson line-height-1 mb1">
          Hjemmeside
        </p>
        <b-form-input id="hejmmeside" type="text" v-model="items.Web" placeholder="" class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
      </div>
    </div>
    <div class="clearfix mb2">
      <button type="submit" class="action-button p2 col-12 border-none not-rounded gibson semi-bold">
        <span class="h5">
          Gem ændringer
        </span>
      </button>
    </div>
  </form>
  <form class="collectReviewForm" @submit="onSubmitInformation" @reset="onReset" v-else>
    <div id="kontaktGroup" class="clearfix mb2">
      <p class="h5 darkblue gibson line-height-1 mb1">
        Kontaktperson
      </p>
      <b-form-input id="contactPerson" type="text" v-model="items.Kontaktperson" required placeholder=""
        class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
    </div>
    <div class="clearfix mb2">
      <p class="h5 darkblue gibson line-height-1 mb1">
        Firmanavn
      </p>
      <b-form-input id="companyName" type="text" v-model="items.Firma" required placeholder=""
        class="muted-background p2 h5 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
    </div>
  <div id="addressGroup" class="clearfix mb2 ">
    <p class="h5 darkblue gibson line-height-1 mb1">
      Adresse
    </p>
    <b-form-input id="address" type="text" v-model="items.Adresse" required placeholder=""
      class="muted-background p2 h5 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
  </div>
  <div id="postGroup" class="clearfix mb2">
    <p class="h5 darkblue gibson line-height-1 mb1">
      Postnr
    </p>
    <b-form-input id="Postnr" type="text" v-model="items.Postnr" required placeholder=""
      class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
  </div>
  <div id="telGroup" class="clearfix mb2">
    <p class="h5 darkblue gibson line-height-1 mb1">
      Telefon
    </p>
    <b-form-input id="telephone" type="text" v-model="items.Telefon" required placeholder=""
      class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
  </div>
  <div id="mobilnummerGroup" class="clearfix mb2">
    <p class="h5 darkblue gibson line-height-1 mb1">
      Mobilnummer
    </p>
    <b-form-input id="mobilnummer" type="text" v-model="items.Mobil" required placeholder=""
      class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
  </div>
    <div id="emailGroup" class="clearfix mb2">
      <p class="h5 darkblue gibson line-height-1 mb1">
        Email
      </p>
      <b-form-input id="email" type="text" v-model="items.Email" required placeholder="" disabled
        class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
    </div>
    <div id="cvrGroup" class="clearfix mb2">
      <p class="h5 darkblue gibson line-height-1 mb1">
        CVR
      </p>
      <b-form-input id="cvr" type="text" v-model="items.Cvrnr" required placeholder="" disabled
        class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
    </div>
    <div id="antalGroup" class="clearfix mb2">
      <p class="h5 darkblue gibson line-height-1 mb1">
        Antal medarbejdere
      </p>
      <b-form-input id="antal" type="text" v-model="items.AntalAnsatte" placeholder=""
        class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
    </div>
    <div id="yearGroup" class="clearfix mb2">
      <p class="h5 darkblue gibson line-height-1 mb1">
        Etableringsår
      </p>
      <b-form-input id="year" type="text" v-model="items.Etableringsaar" placeholder=""
        class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
    </div>
  <div id="hjemmesideGroup" class="clearfix mb2">
    <p class="h5 darkblue gibson line-height-1 mb1">
      Hjemmeside
    </p>
    <b-form-input id="hejmmeside" type="text" v-model="items.Web" placeholder=""
      class="muted-background p2 border-none not-rounded darkblue gibson" style="font-size:16px;"></b-form-input>
  </div>
    <div class="clearfix mb2">
      <button type="submit" class="action-button p2 col-12 border-none not-rounded gibson semi-bold">
        <span class="h5">
          Gem ændringer
        </span>
      </button>
    </div>
  </form>
</template>
<script>
export default {
  name: 'profilsideinformation',
  props: ['items'],
  data () {
    return {
      form: {
        contactPerson: '',
        companyName: '',
        address: '',
        telephone: '',
        email: '',
        cvr: '',
        klippekort: '',
        mobilnummer: '',
        name: '',
        hjemmeside: ''
      },
      showMobile: false
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    if (screen.width >= 1300) {
      this.showXXL = true
    } else {
      this.showXXL = false
    }
  },
  methods: {
    onSubmitInformation (evt) {
      evt.preventDefault()
      this.$emit('clicked')
    },
    onReset (evt) {
      evt.preventDefault()
      /* Reset our form values */
      this.form.contactPerson = ''
      this.form.companyName = ''
      this.form.address = ''
      this.form.email = ''
      this.form.telephone = ''
      this.form.cvr = ''
      this.form.klippekort = ''
      this.form.pbs = ''
      this.form.contractend = ''
      this.form.hjemmeside = ''
    }
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// Profilsideinformation.vue?06b59233